import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyInstantRoomBlockGuest = loadable(
  () =>
    import(
      /* webpackChunkName: "content/guest/instantRoomBlock" */
      './InstantRoomBlockGuest'
    ),
  'InstantRoomBlockGuest',
);
